import React from 'react'

import { sliceBottomPadding } from '../../util/helper'
import BasicImageBlock from './BasicImageBlock'
import VideoBlock from './VideoBlock'
import ImageBlockWithText from './ImageBlockWithText'
import AuthorBlock from './AuthorBlock'
import AccordionBlock from './Accordion'
import CalendarOfEventsBlock from './CalendarOfEventsBlock'
import BodyContentBlock from './BodyContentBlock'
import EventListingBlock from './EventListingBlock'
import EmbeddedForm from './EmbeddedForm'
import RaisersEdgeForm from './RaisersEdgeForm'
import { PageSliceGoogleAdContainer } from '../styles/GoogleAdsCommon.styles'
import CtaBlock from './CtaBlock'
import StatisticsBlock from './StatisticsBlock'
import GridBlock from './GridBlock'
import IconTextBlock from './IconTextBlock'
import PodcastBlock from './PodcastBlock'
import SponsorsBlock from './SponsorsBlock'
import TableBlock from './TableBlock'
import AdvancedForm from './AdvancedForm'
import AdSlot from '../AdSlot'
import FeaturedProductBlock from './FeaturedProductBlock'

import { FORM_TYPE } from '../../util/constants'

const TYPENAMES = {
  basicImageBlock: 'basic_image_block',
  advancedImageBlock: 'advanced_image_block',
  videoBlock: 'video_block',
  authorBlock: 'author_block',
  accordionBlock: 'accordion_block',
  calendarOfEventsBlock: 'calendar_of_events_block',
  researcherProfileBlock: 'researcher_profile',
  bodyContentBlock: 'body_content',
  eventBlock: 'event_block',
  embeddedForm: 'custom_form',
  googleAd: 'google_ad',
  ctaBlock: 'cta_block',
  statisticsBlock: 'statistics_block',
  gridBlock: 'grid_block',
  iconTextBlock: 'icon___text_block',
  podcastBlock: 'podcast',
  sponsorsBlock: 'sponsors_block',
  // raisersEdgeForm: 'raiser_s_edge_form',
  // curatorIoForm: 'curator_social_media_feed',
  // formAssemblyForm: 'formassembly_form',
  // riddleQuizForm: 'riddle_quiz',
  tableBlock: 'table',
  advancedForm: 'advanced_form',
  featuredProductBlock: 'featured_product',
}

const SliceRenderer = ({ block, precomputedJumpLinks = [] }) => {
  const bottomPaddingAdjustment = sliceBottomPadding(
    block.primary?.bottom_padding_adjustment ?? null
  )
  switch (block.slice_type) {
    case TYPENAMES.basicImageBlock:
      return (
        <BasicImageBlock
          data={block.primary}
          bottomPaddingAdjustment={bottomPaddingAdjustment}
        />
      )
    case TYPENAMES.advancedImageBlock:
      return (
        <ImageBlockWithText
          data={block.primary}
          bottomPaddingAdjustment={bottomPaddingAdjustment}
        />
      )
    case TYPENAMES.videoBlock:
      return (
        <VideoBlock
          data={block.primary}
          bottomPaddingAdjustment={bottomPaddingAdjustment}
        />
      )
    case TYPENAMES.authorBlock:
      return (
        <AuthorBlock
          data={block.primary.author?.document ?? null}
          bottomPaddingAdjustment={bottomPaddingAdjustment}
        />
      )
    case TYPENAMES.accordionBlock:
      return (
        <AccordionBlock
          data={block}
          bottomPaddingAdjustment={bottomPaddingAdjustment}
        />
      )
    case TYPENAMES.calendarOfEventsBlock:
      return (
        <CalendarOfEventsBlock
          bottomPaddingAdjustment={bottomPaddingAdjustment}
        />
      )
    case TYPENAMES.bodyContentBlock:
      return (
        <BodyContentBlock
          data={block.primary}
          bottomPaddingAdjustment={bottomPaddingAdjustment}
          precomputedJumpLinks={precomputedJumpLinks}
        />
      )
    case TYPENAMES.eventBlock:
      return (
        <EventListingBlock
          data={block.items}
          bottomPaddingAdjustment={bottomPaddingAdjustment}
        />
      )
    // NOTE: THESE NEXT TWO SHOULD BE REMOVED ONCE THE NEW FORMS IMPLEMENTATION IS COMPLETE
    case TYPENAMES.embeddedForm:
      return (
        <EmbeddedForm
          data={block}
          bottomPaddingAdjustment={bottomPaddingAdjustment}
        />
      )
    case TYPENAMES.raisersEdgeForm:
      return (
        <RaisersEdgeForm
          data={block.primary}
          bottomPaddingAdjustment={bottomPaddingAdjustment}
        />
      )
    case TYPENAMES.googleAd:
      return (
        <PageSliceGoogleAdContainer
          bottomPaddingAdjustment={bottomPaddingAdjustment}
        >
          <AdSlot divId={`div-${block.id}`} />
        </PageSliceGoogleAdContainer>
      )
    case TYPENAMES.ctaBlock:
      return (
        <CtaBlock
          data={block.primary}
          bottomPaddingAdjustment={bottomPaddingAdjustment}
        />
      )
    case TYPENAMES.statisticsBlock:
      return (
        <StatisticsBlock
          data={block.primary}
          bottomPaddingAdjustment={bottomPaddingAdjustment}
        />
      )
    case TYPENAMES.gridBlock:
      return (
        <GridBlock
          data={block}
          bottomPaddingAdjustment={bottomPaddingAdjustment}
        />
      )
    case TYPENAMES.iconTextBlock:
      return (
        <IconTextBlock
          data={block}
          bottomPaddingAdjustment={bottomPaddingAdjustment}
        />
      )
    case TYPENAMES.podcastBlock:
      return (
        <PodcastBlock
          data={block.primary}
          bottomPaddingAdjustment={bottomPaddingAdjustment}
        />
      )
    case TYPENAMES.sponsorsBlock:
      return (
        <SponsorsBlock
          data={block}
          bottomPaddingAdjustment={bottomPaddingAdjustment}
        />
      )
    case TYPENAMES.tableBlock:
      return (
        <TableBlock
          data={block}
          bottomPaddingAdjustment={bottomPaddingAdjustment}
        />
      )
    case TYPENAMES.advancedForm:
      return (
        <AdvancedForm
          data={block.primary}
          bottomPaddingAdjustment={bottomPaddingAdjustment}
        />
      )
    case TYPENAMES.featuredProductBlock:
      return (
        <FeaturedProductBlock
          data={block.primary}
          bottomPaddingAdjustment={bottomPaddingAdjustment}
        />
      )
    default:
      return null
  }
}

export default SliceRenderer
